module.exports = __webpack_public_path__ + "static/media/my-little-paris.2acb6990.png";